import $ from "jquery";

import Vars from '../../vars';

import Validation from "../classes/Validation";
import Modal from "../../components/Modal";
import Request from '../../components/request';
import Utils from "../../components/utils";
import DropzoneMyInformation from "../dropzone/my_information";

class Account {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init(args);
    }

    _elems = {
        $content  : $(),
        $edit     : $(),
        $verify   : $(),
        $switcher : $(),

        $documentLinkAdd    : $(),
        $documentLinkRemove : $(),
        $documentLinkEdit   : $(),
    };

    _const = {
        entity : 'my_information'
    };

    _args = {
        title : ''
    };

    _state = {
        item     : {},
        dropzone : {},

        documentLinks : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.title = args.title
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneMyInformation.get({
            item     : self._state.item,
            parent   : self._state.object,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._state.item;
    };

    _initModal = () => {
        let self = this;

        self._setDropzone();
        new Modal({
            title   : 'Редактирование моей информации',
            content : Utils.renderProfileTemplate(self._const.entity + '-form', {
                [self._const.entity] : self._state.item
            }),
            closingConfirmation : true,
            dropzone : self._state.dropzone,
            confirm : function(args) {
                self._bindConfirmEdit(args);
            }
        });
    };

    _initDocumentLinkModal = (args) => {
        let self = this;
        let isEdit = args.edit ? args.edit : false
        let id = 0;
        if (isEdit) {
            id = args.documentLink.id;
        }

        new Modal({
            title   : (isEdit ? 'Редактирование' : 'Добавление') + ' ссылки на документ',
            content : Utils.renderProfileTemplate(self._const.entity + '-document-link-form', {
                document_link : isEdit ? args.documentLink : null
            }),
            closingConfirmation : true,
            confirm : function(args) {
                if (isEdit) {
                    self._bindConfirmDocumentLinkEdit(id, args)
                }
                else {
                    self._bindConfirmDocumentLinkStore(args);
                }
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$edit = self._elems.$content.find('.js-profile-my-information-edit');
        self._elems.$verify = self._elems.$content.find('.js-profile-my-information-verify');
        self._elems.$switcher = self._elems.$content.find('.switcher__input');

        self._elems.$documentLinkAdd = self._elems.$content.find('.js-profile-document-link-add');
        self._elems.$documentLinkRemove = self._elems.$content.find('.js-profile-document-link-remove');
        self._elems.$documentLinkEdit = self._elems.$content.find('.js-profile-document-link-edit');
    };

    _bindEdit = () => {
        let self = this;
        if (!self._elems.$edit.length) return;

        self._elems.$edit.click(function(e){
            e.preventDefault();
            self._initModal();
        });
    };

    _bindConfirmEdit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path: 		'/api/my-information/edit',
            method: 	'POST',
            data: 		$form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return
                }
                
                $modal.trigger('close');

                self._init();
            },
        });
    };

    _bindVerify = () => {
        let self = this;
        if (!self._elems.$verify.length) return;

        self._elems.$verify.click(function(e){
            e.preventDefault();
            loader.increase();

            Request.send({
                path : '/api/my-information/verify',
                data : $(this).serialize(),

                done: function(response) {
                    loader.decrease();

                    if (response.error) {
                        console.error(response.error);
                        return;
                    }

                    self._state.item = response[self._const.entity];

                    new Modal({
                        title   : 'Подтверждение e-mail',
                        content : Utils.renderProfileTemplate(self._const.entity + '-verifing', {
                            [self._const.entity] : self._state.item
                        }),
                        closingConfirmation : false
                    });
                },
            });
        });
    };

    _bindConfirmDocumentLinkStore = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path: 		'/api/document_links',
            method: 	'POST',
            data: 		$form.serialize(),

            done: function(response) {
                loader.decrease();

                $modal.trigger('close');

                self._init();
            },

            validate : function (response) {
                let error = {
                    type : 'validation',
                    fields : response.errors
                }
                validation.showErrors(error);
            }
        });
    };

    _bindConfirmDocumentLinkEdit = (id, args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path: 		'/api/document_links/' + id,
            method: 	'POST',
            data: 		$form.serialize(),

            done: function(response) {
                loader.decrease();

                $modal.trigger('close');

                self._init();
            },

            validate : function (response) {
                let error = {
                    type : 'validation',
                    fields : response.errors
                }
                validation.showErrors(error);
            }
        });
    };

    _bindSwitcher = () => {
        let self = this;
        if (!self._elems.$switcher.length) return;

        self._elems.$switcher.click(function(){
            let $input = $(this);
            if ($input.is(':checked')) {
                let $item = $(this);
                window.location.href = '/login/' + $item.data('name');
            }
            else {
                $input.prop('checked', true);
                new Modal({
                    title   : 'Подтверждение удаления привязки профиля социальной сети',
                    content : Utils.renderProfileTemplate('info', {
                        message : 'Вы действительно хотите удалить привязку с данной социальной сети?',
                        buttons : {
                            one : {
                                class : 'confirm button--remove',
                                title : 'Да, удалить'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Нет, отменить'
                            }
                        }
                    }),
                    confirm : function(args) {
                        let $modal = args.modal;
                        if (!$modal.length) return;

                        loader.increase();

                        Request.send({
                            path: 		'/api/login/' + $input.data('name') + '/unlink',
                            method: 	'POST',

                            done: function(response) {
                                loader.decrease();

                                $modal.trigger('close');

                                if (response.error) {
                                    new Modal({
                                        title: 'Информация',
                                        content: Utils.renderProfileTemplate('info', {
                                            message: response.text,
                                            buttons: {
                                                one: {
                                                    class: 'confirm button--edit',
                                                    title: 'Хорошо'
                                                },
                                                two: null
                                            }
                                        }),
                                        confirm: function (args) {
                                            let $modal = args.modal;
                                            if (!$modal.length) return;

                                            $modal.trigger('close');
                                        }
                                    });

                                    return
                                }

                                $input.prop('checked', false);
                            },
                            error: function(){
                                loader.increase();
                                input.prop('checked', true);

                                new Modal({
                                    title: 'Ошибка',
                                    content: Utils.renderProfileTemplate('info', {
                                        message: 'К сожалению, не удалось отвязать социальную сеть от вашего аккаунту',
                                        buttons: {
                                            one: {
                                                class: 'confirm button--edit',
                                                title: 'Хорошо'
                                            },
                                            two: null
                                        }
                                    }),
                                    confirm: function (args) {
                                        let $modal = args.modal;
                                        if (!$modal.length) return;

                                        $modal.trigger('close');
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
    };

    _bindDocumentLinks = () => {
        let self = this;

        self._elems.$documentLinkAdd.length && self._elems.$documentLinkAdd.click(function(e){
            e.preventDefault();
            self._initDocumentLinkModal({
                edit : false
            });
        });

        self._elems.$documentLinkRemove.length && self._elems.$documentLinkRemove.click(function(e){
            e.preventDefault();

            const ID = $(this).data('id');

            new Modal({
                title: 		'Удаление документа',
                content: 	Utils.renderProfileTemplate('info', {
                    message : 'Вы действительно хотите выделить ссылку на этот документ?',
                    buttons : {
                        one : {
                            class : 'confirm button--remove',
                            title : 'Да, удалить'
                        },
                        two : {
                            class : 'button--cancel',
                            title : 'Нет'
                        }
                    }
                }),
                confirm : function(args) {
                    let $modal = args.modal;

                    Request.send({
                        path: 		'/api/document_links/' + ID,
                        method: 	'DELETE',

                        done: function() {
                            loader.decrease();

                            $modal.trigger('close');
                            self._init();
                        },
                        fail : function() {
                            $modal.trigger('close');
                        }
                    });
                }
            });
        });

        self._elems.$documentLinkEdit.length && self._elems.$documentLinkEdit.click(function(e){
            e.preventDefault();

            const ID = $(this).data('id');

            self._initDocumentLinkModal({
                edit         : true,
                documentLink : self._state.documentLinks.filter(dl => dl.id == ID)[0]
            });
        });
    };

    _bindUI = () => {
        let self = this;

        self._bindEdit();
        self._bindVerify();
        self._bindSwitcher();

        self._bindDocumentLinks();
    };

    _init = () => {
        let self = this;

        self._bindElements();

        Request.send({
            queue : [
                {
                    path: '/api/my-information'
                },
                {
                    path: '/api/document_links'
                }
            ],
            done : function(response, extraResponse){
                loader.decrease();

                self._state.item = response[self._const.entity];
                self._state.documentLinks = extraResponse.data;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : self._args.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item,
                    document_links       : self._state.documentLinks
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    }
}

export default Account;